import theme from '@/src/config/theme'
import styled from "styled-components";

export const Info = styled.div`
  font-size: 1.4285714286rem;
  font-weight: 450;
  
  &[data-error] {
    padding: 10px;
    border-radius: 5px;
    border: solid 1px ${theme.colors.error};
  }
`
